/**
 * Role Utilities
 * Normalizes and validates user roles
 */

// Role mapping - normalize various role names to standard roles
export const userRoles = {
  'developer': 'developer',
  'dev': 'developer',
  '開發者': 'developer',
  'student': 'student',
  'teacher': 'teacher',
  'admin': 'admin',
  'parent': 'parent',
  'staff': 'staff'
};

/**
 * Normalize a role string to a standard role
 * @param {string} role - The role to normalize
 * @returns {string} - Normalized role
 */
export const normalizeRole = (role) => {
  if (!role) return null;
  
  const normalized = role.toLowerCase().trim();
  return userRoles[normalized] || normalized;
};

/**
 * Check if a role is a developer role
 * @param {string} role - The role to check
 * @returns {boolean} - True if the role is a developer
 */
export const isDeveloperRole = (role) => {
  const normalized = normalizeRole(role);
  return normalized === 'developer';
};

/**
 * Check if a role is an admin role
 * @param {string} role - The role to check
 * @returns {boolean} - True if the role is an admin
 */
export const isAdminRole = (role) => {
  const normalized = normalizeRole(role);
  return normalized === 'admin';
};

